export const IDH_BRAND_COLOR = "#5D78FF";
